var render = function () {
  var _class;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: (_class = {}, _class[_vm.$style.eventBlock] = true, _class[_vm.$style.minimalDesign] = _vm.minimalDesign, _class['light-transparent'] = _vm.isTransparent && _vm.minimalDesign, _class),
    attrs: {
      "data-event-block": ""
    },
    on: {
      "mouseover": function mouseover($event) {
        _vm.isTransparent = true;
      },
      "mouseout": function mouseout($event) {
        _vm.isTransparent = false;
      },
      "click": _vm.clickEventBlock
    }
  }, [_vm.loadingFavorite ? _c('LoaderIcon', {
    staticClass: "d-inline",
    class: _vm.$style.heartIcon
  }) : _vm.event.eventId ? _c('FavoriteHeart', {
    class: _vm.$style.heartIcon,
    attrs: {
      "is-favorite": _vm.isFavorite
    },
    on: {
      "handleHeartClick": _vm.handleHeartClick
    }
  }) : _vm._e(), _c('div', {
    class: _vm.$style.dateInfo,
    style: {
      border: "1px solid ".concat(_vm.getEventColorHex(_vm.event.eventType))
    }
  }, [_c('p', {
    class: _vm.$style.month,
    style: {
      color: "".concat(_vm.getEventColorHex(_vm.event.eventType))
    }
  }, [_vm._v(" " + _vm._s(_vm.dateInfoText.month.toUpperCase()) + " ")]), _c('h1', {
    class: _vm.$style.dayNumber,
    style: {
      color: "".concat(_vm.getEventColorHex(_vm.event.eventType))
    },
    attrs: {
      "data-event-day": ""
    }
  }, [_vm._v(_vm._s(_vm.dateInfoText.day))]), _c('h4', {
    class: _vm.$style.dayText,
    style: {
      color: "".concat(_vm.getEventColorHex(_vm.event.eventType))
    }
  }, [_vm._v(" " + _vm._s(_vm.dateInfoText.weekday.toUpperCase()) + " ")]), _vm.event.multiDay ? _c('p', {
    staticClass: "p2",
    class: _vm.$style.multidayText,
    style: {
      color: "".concat(_vm.getEventColorHex(_vm.event.eventType))
    }
  }, [_vm._v(" DAY " + _vm._s(_vm.getDaysDiff(_vm.currentDate, _vm.event.start) > 0 ? _vm.getDaysDiff(_vm.currentDate, _vm.event.start) : 1) + " ")]) : _vm._e(), _c('p', {
    staticClass: "p2",
    class: _vm.$style.time,
    style: {
      color: "".concat(_vm.getEventColorHex(_vm.event.eventType))
    }
  }, [_vm._v(" " + _vm._s(_vm.event.allDay ? 'ALL DAY' : _vm.getStartTimeTexts.time) + " ")]), !_vm.event.allDay && _vm.getEndTimeTexts.time ? [_c('p', {
    staticClass: "p2",
    class: _vm.$style.time,
    style: {
      color: "".concat(_vm.getEventColorHex(_vm.event.eventType))
    }
  }, [_vm._v("To")]), _c('p', {
    staticClass: "p2",
    class: _vm.$style.time,
    style: {
      color: "".concat(_vm.getEventColorHex(_vm.event.eventType))
    }
  }, [_vm._v(" " + _vm._s(_vm.getEndTimeTexts.time) + " ")])] : _vm._e()], 2), _c('div', {
    class: _vm.$style.eventInfo
  }, [_c('p', {
    staticClass: "tag-text",
    class: _vm.$style.eventTitle
  }, [_vm._v(_vm._s(_vm.event.title.toUpperCase()))]), _vm.event.multiDay ? _c('p', {
    staticClass: "tag-text",
    class: _vm.$style.eventDateRangeText
  }, [_vm._v(" " + _vm._s(_vm.getStartTimeTexts.weekday) + ", " + _vm._s(_vm.getStartTimeTexts.monthShort) + " " + _vm._s(_vm.getStartTimeTexts.day) + " - " + _vm._s(_vm.getEndTimeTexts.weekday) + ", " + _vm._s(_vm.getEndTimeTexts.monthShort) + " " + _vm._s(_vm.getEndTimeTexts.day) + " ")]) : _vm._e(), _c('p', {
    staticClass: "p2",
    class: _vm.$style.eventDescription
  }, [_vm._v(_vm._s(_vm.event.descriptionTruncated))]), _vm.event.location ? _c('div', {
    class: _vm.$style.locationDetails
  }, [_c('MottoIcon', {
    attrs: {
      "name": "Place"
    }
  }), _c('p', {
    staticClass: "p2"
  }, [_vm._v(_vm._s(_vm.event.location))])], 1) : _vm._e(), _c('p', {
    staticClass: "button-text",
    class: _vm.$style.learnMoreText,
    on: {
      "click": _vm.viewEvent
    }
  }, [_vm._v("Learn More")])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }